import React from 'react';
import Layout from "../components/layout";
import {H3} from "../utils/Typography";
import SEO from "../components/seo";
import img from "../images/Data structure/Data Structuring 2.png";
import ProductHeader1 from "../utils/ProductHeader1";
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ImageHeader from "../utils/ImageHeader";
import ImageFooter from "../utils/ImageFooter";
import secure from "../images/Data structure/Secure 3.png";
import lock from "../images/Data structure/lock.png";
import efficiencies from "../images/Data structure/Efficiencies 3.png";
import cost from "../images/Data structure/Cost Reduction 3.png";
import API from "../images/Data structure/API 3.png";
import traceability from "../images/Data structure/Traceability 3.png";
import audit from "../images/Data structure/Audit trail 3.png";
import data from "../images/Data structure/Clarity of data 3.png";
import request from "../images/Data structure/Allow for Non-Standard Request 3.png";
import img1 from "../images/Data structure/2-2-5.png";
import styled from "styled-components";
import CompanyFooter from "../utils/CompanyFooter";

const IndexHeader = styled.div`
display: flex;
grid-template-columns: 1fr;
grid-template-rows: 1fr;
align-items: left;
justify-items: left;

`;

const Products = () => {
    return (
        <Layout>
            <SEO title="Home" keywords={[`u-reg`, `ureg`, `KYC`, `utility`]}/>
            <div className="container">
                <br></br><br></br><br></br>
            <ProductHeader1 img={img} />
            </div>
            <br></br>
            {/* <Container>
            <font face="Arial">
                <Row css={{fontSize: '14px'}}>
                   <Col></Col>
                    <Col>
                        <Row>
                            <Col xs={4}>
                                <IndexHeader>
                                    <ImageHeader img={secure} />
                                </IndexHeader>
                                <IndexHeader>
                                    <ImageHeader img={cost} />
                                </IndexHeader>
                                <IndexHeader>
                                    <ImageHeader img={API} />
                                </IndexHeader>
                                <IndexHeader>
                                    <ImageHeader img={traceability} />
                                </IndexHeader>
                            </Col>
                            <Col>
                                <IndexHeader>
                                    <ImageHeader /><div>SECURE</div>
                                </IndexHeader>
                                <IndexHeader>
                                    <ImageHeader /><div>COST REDUCTION</div>
                                </IndexHeader>
                                <IndexHeader>
                                    <ImageHeader /><div>API</div>
                                </IndexHeader>
                                <IndexHeader>
                                    <ImageHeader /><div>TRACEABILITY</div>
                                </IndexHeader>
                            </Col>
                        </Row>


                    </Col>
                    <Col>
                        <Row>
                            <Col xs={4}>
                                <IndexHeader>
                                    <ImageHeader img={efficiencies} />
                                </IndexHeader>
                                <IndexHeader>
                                <ImageHeader img={audit} />
                                </IndexHeader>
                                <IndexHeader>
                                <ImageHeader img={data} />
                                </IndexHeader>
                                <IndexHeader>
                                <ImageHeader img={request} />
                                </IndexHeader>
                            </Col>
                            <Col>
                                <IndexHeader>
                                    <ImageHeader /><div>EFFICIENCIES</div>
                                </IndexHeader>
                                <IndexHeader>
                                    <ImageHeader /><div>AUDIT TRAIL</div>
                                </IndexHeader>
                                <IndexHeader>
                                    <ImageHeader /><div>CLARITY OF DATA</div>
                                </IndexHeader>
                                <IndexHeader>
                                    <ImageHeader /><div><p css={{'margin-bottom':'0rem'}}>NON-STANDARD</p>
                                        <p css={{'margin-bottom':'0rem'}}>REQUESTS</p></div>
                                </IndexHeader>
                            </Col>
                        </Row>

                    </Col>
                    <Col><ImageFooter img={img1} /></Col>
                </Row>
                </font>
            </Container> */}
               <div className="container" >
            <CompanyFooter img={img1}/>   
            </div> 
        </Layout>
    );
};

export default Products;
